import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import ColorWrapper from '@styles/colors';
import BaseFrame from './baseFrame';
import i18n from 'i18n-js';

import { getCountryCodes, updateCompanyProfileValue } from '@reducers/membership';

const BaseModal = (props) => {
  const { user, getCountryCodes, updateCompanyProfileValue } = props;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const companyProfile = user?.userInfo?.companyProfile || {};
  const [selected, setSelected] = useState(`${companyProfile.countryName} (${companyProfile.countryCode})`);
  const [parameters, setParameters] = useState({});

  useEffect(() => {
    (async () => {
      const d = await getCountryCodes();
      if (d) {
        setData(d.map((i) => ({ name: i18n.t(i?.englishName), value: `${i.nativeName} (${i.countryCode})`, parameters: i })));
      }
      setLoading(false);
    })();
  }, []);

  const onSelect = (item) => {
    setSelected(item.value);
    setParameters(item.parameters);
  };

  const onCancel = () => {};
  const onSubmit = async () => {
    setSubmitLoading(true);
    await updateCompanyProfileValue({ countryCode: parameters.countryCode, countryName: parameters.nativeName });
    setSubmitLoading(false);
  };

  return (
    <BaseFrame
      {...{
        loading,
        submitLoading,
        data,
        onCancel,
        onSelect,
        onSubmit,
        header: 'Country',
        selected,
        ...props,
      }}
    />
  );
};

export default connect(({ user }) => ({ user }), { getCountryCodes, updateCompanyProfileValue })(ColorWrapper(BaseModal));
